<template>
  <div
    v-if="maintenanceMode"
    role="status"
    class="bg-[#eecf6d] text-zinc-900"
  >
    <div class="max-w-6xl mx-auto px-5 lg:px-8 py-2.5 flex items-center justify-center gap-2.5 text-center text-sm">
      <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      </svg>
      <p>
        <strong class="font-semibold">{{ maintenanceMessage.title }}.</strong>
        {{ maintenanceMessage.banner }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { maintenanceMode, maintenanceMessage } from '../../utils/maintenance.js'
</script>
